// バリデーションメッセージ
export const REQUIRED_ERROR = "入力してください";
export const SELECT_REQUIRED_ERROR = "選択してください";
export const EMAIL_INVALID_ERROR = "メールアドレスの形式になっていません";
export const HALF_SIZE_NUMBER_AND_SYMBOL_ONLY = "半角英数字と @ のみで入力してください";
export const HALF_SIZE_NUMBER_ONLY = "半角数字で入力してください";
export const MAX_LENGTH_ERROR = (maxLength: number) => `${maxLength}文字以内で入力してください`;
export const MIN_LENGTH_ERROR = (minLength: number) => `${minLength}文字以上の半角英数字で入力してください`;
export const MAX_PRICE_ERROR = (maxLength: number) => `${maxLength}桁以内で入力してください`;
export const MAX_SELECT_ERROR = (maxNum: number) => `${maxNum}件以内で選択してください`;
